import React from 'react'

const WindowsRequirements = (props) => {
  return (
    <div className="tab">
      <h2>Microsoft Windows</h2>
      <span className="osDetails">Windows 7 or newer</span>

      <div className="supportTable">
        <div className="row columnHeader">
          <div className="column windows"></div>
          <div className="column">Win 7</div>
          <div className="column">Win 8</div>
          <div className="column">Win 10</div>
        </div>
        <div className="row">
          <div className="column leftAlign windows">IE 11</div>
          <div className="column"><span className="support"></span></div>
          <div className="column"><span className="support"></span></div>
          <div className="column"><span className="support"></span></div>
        </div>
        <div className="row">
          <div className="column leftAlign windows">Edge</div>
          <div className="column"><span className="noSupport"></span></div>
          <div className="column"><span className="noSupport"></span></div>
          <div className="column"><span className="support"></span></div>
        </div>
        <div className="row">
          <div className="column leftAlign windows">Chrome</div>
          <div className="column"><span className="support"></span></div>
          <div className="column"><span className="support"></span></div>
          <div className="column"><span className="support"></span></div>
        </div>
      </div>
    </div>
  )
}

export default WindowsRequirements
